<template>
  <section>
    <b-modal :active.sync="isComponentModalActive" has-modal-card :can-cancel="false">
      <div class="modal-card">
        <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
        <header class="modal-card-head">
          <p v-if="!this.document_type_id" class="modal-card-title">Crear Tipo de Documento</p>
          <p v-else class="modal-card-title">Editar Tipo de Documento</p>
        </header>
        <section class="modal-card-body">
          <b-field label="Nombre">
            <b-input
              type="text"
              :value="documentType.name"
              v-model="documentType.name"
              placeholder="Nombre"
              required
            ></b-input>
          </b-field>
        </section>
        <footer class="modal-card-foot">
          <button class="button" type="button" @click="closeBasic()">Cerrar</button>
          <button v-if="!this.document_type_id" class="button is-primary" @click="createDocumentType()">Guardar</button>
          <button v-else class="button is-primary" @click="editDocumentType()">Editar</button>
        </footer>
      </div>
    </b-modal>
  </section>
</template>
<script>
import {DocumentTypeService} from "../../../services/models/document_type";
export default {
  props: [
    "isComponentModalActive",
    "closeBasic",
    "chargeDocumentTypeList",
    "document_type_id",
  ],
  data() {
    return {
      documentType: {
        name: "",
      },
      isLoading: false,
    };
  },
  async created () {
    this.isLoading = true;
    if (this.document_type_id) {
      const {data} = await DocumentTypeService.getById(this.document_type_id);
      this.documentType = data;
    }
    this.isLoading = false;
  },
  methods: {
    async createDocumentType () {
      this.isLoading = true;
      try {
        await DocumentTypeService.create(this.documentType);
        this.chargeDocumentTypeList();
        this.closeBasic();
        this.toast("Creado el tipo de documento", "is-success");
      } catch (err) {
        this.toast("Error al crear", "is-danger");
      }
      this.isLoading = false;
    },
    async editDocumentType () {
      this.isLoading = true;
      try {
        await DocumentTypeService.update( this.document_type_id,this.documentType);
        this.chargeDocumentTypeList();
        this.closeBasic();
        this.toast("Editado el tipo de bodega", "is-success");
      } catch (error) {
        this.toast("Error al editar", "is-danger");
      }
      this.isLoading = false;
    }
  },
};
</script>